<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="overflow-hidden" style="height:300px;">
        <div slot="no-body">

          <div class="p-6 float-left" :class="{
            'flex justify-between flex-row-reverse items-center': iconRight,
            'text-center': !iconRight && hideChart,
            'pb-0': !hideChart
          }">
            <div>

                <feather-icon :icon="icon" class="p-3 inline-flex rounded-full" :class="[`text-${color}`, {'mb-4': !iconRight}]" :style="{background: `rgba(var(--vs-${color}),.15)`}"></feather-icon>
                <div class="truncate">
                    <h2 class="mb-1 font-bold">{{ formattedStatistics }}</h2>
                    <span>{{ $t(i18n) || title }}</span>
                </div>
            </div>
            
          </div>
          <div class="p-2 float-right">
            <vs-row vs-type="flex" vs-justify="flex-end">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" class="mr-1">
                <vs-button v-if="enableZoomIn" type="flat" icon-pack="feather" size="large" icon="icon-search" color="primary" @click="zoomIn"></vs-button>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
                <vs-button v-if="enableDrilling" type="flat" icon-pack="feather" size="large" icon="icon-corner-right-down" color="primary" @click="drillTo"></vs-button>
              </vs-col>
            </vs-row>
          </div>
          <div class="line-area-chart" v-if="!hideChart">
            <vue-apex-charts ref="apexChart" :type="type" height="100" width="100%" :options="chartOptions" :series="chartData" />
          </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import chartConfigs from './chartConfigs.js'
import _color from '@/assets/utils/color.js'
import shared from '@/filters/shared.js'

export default {
  props: {
    icon: {
      type: String,
      required: false
    },
    statistic: {
      type: [Number, String],
      required: false
    },
    dataFilter: {
      type: String
    },
    title: {
      type: String
    },
    i18n : {
      type: String
    },
    chartData: {
      // type: Array,
      // required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    linkTo: {
      type: String
    },
    colorTo: {
      type: String
    },
    type: {
      type: String,
      default: 'line'
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    enableZoomIn: {
      type: Boolean,
      default: false
    },
    hideChart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chartOptions: null,
      zoomPopupActive : false
    }
  },
  watch: {
    themePrimaryColor () {
      this.$refs.apexChart.updateOptions({ theme: { monochrome: { color: this.getHex(this.color) } } })
    }
  },
  computed: {
    themePrimaryColor () {
      return this.$store.state.themePrimaryColor
    },
    formattedStatistics() {
      return shared.formatValue(this.statistic, this.dataFilter, this);
    },
    enableDrilling() {
      return this.linkTo !== "" && typeof this.linkTo !== 'undefined';
    }
  },
  methods: {
    zoomIn() {
      this.$emit("onZoomIn");
    },
    drillTo() {
      this.$emit("onDrillTo", this.linkTo);
    },
    getHex (color) {
      if (_color.isColor(color)) {
        let rgb  = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${color}`)
        rgb = rgb.split(',')
        return `#${  ((1 << 24) + (Number(rgb[0]) << 16) + (Number(rgb[1]) << 8) + Number(rgb[2])).toString(16).slice(1)}`
      }
      return color
    },
    gradientToColor (color) {
      const gradientToColors = {
        'primary': '#A9A2F6',
        'success': '#55DD92',
        'warning': '#ffc085',
        'danger': '#F97794'
      }

      return gradientToColors[color] ? gradientToColors[color] : gradientToColors['primary']
    }
  },
  components: {
    VueApexCharts
  },
  created () {
    if (this.type === 'area') {
      // assign chart options
      this.chartOptions = Object.assign({}, chartConfigs.areaChartOptions)

      this.chartOptions['theme'] = {
        monochrome: {
          enabled: true,
          color: this.getHex(this.color),
          shadeTo: 'light',
          shadeIntensity: 0.65
        }
      }
    } else if (this.type === 'line') {
      // Assign chart options
      this.chartOptions = JSON.parse(JSON.stringify(chartConfigs.lineChartOptions))

      this.chartOptions.fill.gradient.gradientToColors = [this.gradientToColor(this.colorTo || this.color)]
      this.chartOptions.colors = [this.getHex(this.color)]
    }
  }
}
</script>
